import {
  ProjectsTableStore,
  PROJECTS_TABLE_STORE
} from 'store'
import { TableContainerProps } from '../TableContainer'

export type ProjectsTableProps = TableContainerProps & {
  [PROJECTS_TABLE_STORE]?: ProjectsTableStore
}

// export const projectsTableWidths = {
//   name: 29,
//   type: 9,
//   addedAt: 10,
//   tags: 17,
//   genre: 12,
//   status: 9,
//   published: 8,
//   openInEditor: 6,
//   deleteProject: 6
// }

export const projectsTableWidths = {
  name: 500,
  type: 150,
  addedAt: 180,
  tags: 300,
  genre: 180,
  status: 160,
  published: 150,
  inputTokenUsed: 150,
  outputTokenUsed: 150,
  openInEditor: 90,
  deleteProject: 95
}
